export const appBtns = [
  {
    img: "photos",
    width: 21,
    height: 21
  },
  {
    className: "blue",
    img: "appstore",
    width: 22,
    height: 20
  },
  {
    img: "faceapps",
    width: 35.1,
    height: 26.5
  },
  {
    className: "darkGrey",
    img: "applepay",
    width: 29,
    height: 12.5
  },
  {
    img: "animalface",
    width: 26,
    height: 24.5
  },
  {
    className: "red",
    img: "racket",
    width: 19,
    height: 19
  },
  {
    className: "black",
    img: "heartapp",
    width: 20,
    height: 18
  }
];